(() => {
  const initialized = new WeakSet();
  const notifySelector = '.nm-widget[data-widget-id="back-in-stock"] button.nm-trigger[data-nm-open]';
  const notifyLabel = document.querySelector('script[data-rs-notify-label]')?.dataset.rsNotifyLabel?.trim();

  const translateNotify = (button) => {
    if (!notifyLabel || !button.matches?.(notifySelector)) return;
    if (button.textContent.trim() !== notifyLabel) button.textContent = notifyLabel;
    if (button.getAttribute('aria-label') !== notifyLabel) button.setAttribute('aria-label', notifyLabel);
  };

  const bind = (element) => {
    if (initialized.has(element)) return;
    const form = element.closest('form');
    if (!form) return;
    let config;
    try { config = JSON.parse(element.textContent); } catch (_) { return; }
    if (!config || !config.variants) return;
    initialized.add(element);

    const sync = (variant) => {
      const input = form.elements.namedItem('id');
      const id = variant === null ? '' : String(variant?.id ?? input?.value ?? '');
      const known = Object.prototype.hasOwnProperty.call(config.variants, id);
      const canOrder = known && (typeof variant?.available === 'boolean' ? variant.available : config.variants[id] === true);
      const label = canOrder ? config.button : known ? config.sold_out : config.unavailable;

      form.querySelectorAll('[data-rs-preorder-property]').forEach((property) => { property.disabled = !canOrder; });
      form.querySelectorAll('[data-rs-preorder-message]').forEach((message) => { message.hidden = !canOrder; });
      form.querySelectorAll('buy-buttons button[type="submit"], [data-rs-preorder-submit]').forEach((button) => { button.textContent = label; });
      form.querySelectorAll('[data-rs-preorder-quick-add]').forEach((button) => { button.setAttribute('aria-label', label); });

      if (form.id && document.getElementById(form.id) === form) {
        document.querySelectorAll('buy-buttons[form]').forEach((buttons) => {
          if (buttons.getAttribute('form') === form.id && !buttons.closest('form')) {
            const button = buttons.querySelector('button[type="submit"]');
            if (button) button.textContent = label;
          }
        });
      }

      const productInfo = form.closest('.product-info');
      productInfo?.querySelectorAll('[data-rs-stock-delivery]').forEach((note) => {
        if (note.dataset.formId === form.id) {
          const message = note.querySelector('[role="status"]');
          if (message) message.textContent = canOrder ? config.delivery : config.contact;
        }
      });
    };

    form.addEventListener('variant:change', (event) => { queueMicrotask(() => sync(event.detail?.variant ?? null)); });
    form.addEventListener('change', (event) => { if (event.target.name === 'id') queueMicrotask(() => sync()); });
    form.addEventListener('submit', () => sync(), true);
    sync();
  };

  const scan = (root) => {
    if (root.matches?.('[data-rs-preorder-config]')) bind(root);
    root.querySelectorAll?.('[data-rs-preorder-config]').forEach(bind);
    if (root.matches?.(notifySelector)) translateNotify(root);
    root.querySelectorAll?.(notifySelector).forEach(translateNotify);
  };

  const start = () => {
    scan(document);
    new MutationObserver((records) => {
      records.forEach((record) => {
        const target = record.target.nodeType === 1 ? record.target : record.target.parentElement;
        if (target?.matches(notifySelector)) translateNotify(target);
        record.addedNodes.forEach((node) => {
          if (node.nodeType === 1) scan(node);
          else if (node.nodeType === 3 && node.parentElement) translateNotify(node.parentElement);
        });
      });
    }).observe(document.body, { childList: true, characterData: true, subtree: true });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
